import { render, staticRenderFns } from "./Audit-item-type.vue?vue&type=template&id=bf050868"
import script from "./Audit-item-type.vue?vue&type=script&lang=js"
export * from "./Audit-item-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports